module.exports = __webpack_public_path__ + "img/derby_1248.7c4baf29.png";